(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-to-button"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__codyScrollInit) return;
    window.__codyScrollInit = true;

    var prefersReduced = window.matchMedia
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function resolveTarget(raw) {
      if (!raw) return null;
      var id = String(raw).replace(/^#/, '').trim();
      if (!id) return null;
      var safe = (window.CSS && CSS.escape) ? CSS.escape(id) : id;
      return (
        document.getElementById(id) ||
        document.getElementById('shopify-section-' + id) ||
        document.querySelector('#' + safe) ||
        document.querySelector('[data-cody-anchor="' + id + '"]') ||
        null
      );
    }

    document.addEventListener('click', function (e) {
      var link = e.target.closest ? e.target.closest('[data-cody-scroll]') : null;
      if (!link) return;

      var raw = link.getAttribute('data-target');
      var target = resolveTarget(raw);
      if (!target) return; // nothing to scroll to — let the browser handle the link

      e.preventDefault();

      var offset = parseInt(link.getAttribute('data-offset'), 10);
      if (isNaN(offset)) offset = 0;

      var top = target.getBoundingClientRect().top + window.pageYOffset - offset;

      window.scrollTo({
        top: top < 0 ? 0 : top,
        behavior: prefersReduced ? 'auto' : 'smooth'
      });

      if (window.history && history.replaceState) {
        history.replaceState(null, '', '#' + String(raw).replace(/^#/, ''));
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
